import { registerPackage, loadPackages } from './modules/PackageManager';
import CookieConsentPackage from './packages/CookieConsentPackage';

registerPackage({
  name: 'cookie-consent',
  loader: () => Promise.resolve({ default: CookieConsentPackage }),
});

registerPackage({
  name: 'navigation',
  loader: () => import('./packages/NavigationPackage'),
});

registerPackage({
  name: 'home-search',
  loader: () => import('./packages/HomeSearchPackage'),
  route: 'home',
});

registerPackage({
  name: 'trip-detail',
  loader: () => import('./packages/TripDetailPackage'),
  route: 'trip.show',
});

registerPackage({
  name: 'trip-index',
  loader: () => import('./packages/TripIndexPackage'),
  route: 'trip.index',
});

// Load packages
document.addEventListener('DOMContentLoaded', loadPackages);
